import { catchError, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of, EMPTY } from 'rxjs';
import * as Api from '../../../store/batches/batches.api';
import * as Actions from './batch-note.actions';

export const saveOrEditBatchNoteRequestEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.SAVE_OR_EDIT_BATCH_NOTE_REQUEST),
    mergeMap((action) => {
      const { batchId, name, note, assignedToGuid } = action;
      return Api.saveBatch(batchId, name, note, assignedToGuid).pipe(
        mergeMap(() => {
          return of(Actions.saveOrEditBatchNoteSuccess(batchId, note));
        }),
      );
    }),
    catchError(() => EMPTY),
  );
};
